module.exports = __webpack_public_path__ + "img/icon-kxgcw.7cdc79ee.png";